import React , { useState , useEffect } from "react";
import { useDispatch  } from "react-redux";
import { Input } from "reactstrap";
import { update_bot_details, Update_Bot_Title } from "../../slices/thunks";
import { useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";

const Bot_Tittle = ({ Bot_Title, Bot_Group, Bot_Assistant }) => {

  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const [edit_mode, set_edit_mode] = useState(false)
  const [bot_title_value, setbot_title_value] = useState(BotDetails.Bot_Title)
  const { loading} = useSelector((state)=> state.BotDetails)
  const dispatch = useDispatch()


  useEffect(() => {
    setbot_title_value(BotDetails.Bot_Title)
  }, [BotDetails])
  


  


  return (
    <div className="flex-grow-1 ms-2">
      <h5 className="list-title fs-15 mb-1">
       {loading || !bot_title_value ? <Loader/>: <div className="tittle_wrap">
          {/* <span> <Input type='text' /> <i className='ri-check-fill'></i></span>            */}
         { !edit_mode ?<> <span style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        
            {bot_title_value}{" "}
            <i onClick={()=>{
              set_edit_mode(true);
             }}  className=" ri-pencil-fill"></i>
          </span>{" "}</>
          :
          <>
          <span style={{ display: "flex", alignItems: "center", gap: "2px" }}>
            
            <Input value={bot_title_value} onChange={(e)=>{
              setbot_title_value(e.target.value);
            }} type="text" />
             <i onClick={()=>{
              dispatch(update_bot_details({ title:bot_title_value , Assistant_Id:BotDetails.Assets_ID , Bot_ID:BotDetails.Bot_ID }))
              set_edit_mode(false);
             }} className="ri-check-fill">
              </i>  
            
           
          </span>{" "}
          </>
          }

          ({BotDetails.Group_Name})
        </div>}
      </h5>
      <p className="list-text mb-0 fs-12 assist_id">ID: {BotDetails.Bot_ID}</p>
    </div>
  );
};

export default Bot_Tittle;
